// --- Inline icon assets (replace `#/assets/*` host imports) ---

/** Inline replacement for `#/assets/TerminalIcon`. */
export function TerminalIcon({
  size = 24,
  color = 'currentColor',
}: {
  readonly size?: number;
  readonly color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="2.5"
        y="4.5"
        width="19"
        height="15"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M6 9l3 3-3 3M11 15h6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SendIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 13V3M8 3L3.5 7.5M8 3L12.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SlashIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 17 17" fill="none">
      <rect
        x="0.5"
        y="0.5"
        width="16"
        height="16"
        rx="4"
        stroke="currentColor"
      />
      <path
        d="M10.7148 3.86816L7.39258 13.1318H6.28516L9.61328 3.86816H10.7148Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StopIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16">
      <rect x="3" y="3" width="10" height="10" rx="1.5" fill="currentColor" />
    </svg>
  );
}
